import styled from 'styled-components';

export const bgDrop = styled.div`
  width:100%;
  height:100%;
  background:rgba(20, 24, 35, 0.7);
  position:fixed;
  top:0px;
  left:0px;
  z-index:1;
`;

export const evCabPopup = styled.div`
  width:673px;
  height:651px;
  background:#fff;
  border-radius:20px;
  position:fixed;
  top:0px;
  right:0px;
  bottom:0px;
  left:0px;
  margin:auto;
  z-index:100;

  & .close{
    width:24px;
    height:24px;
    position:absolute;
    top:-40px;
    right:0px;
    display:flex;
    cursor:pointer;
  }

  .close:before{
    content:"";
    background:#fff;
    position: absolute;
    width: 24px;
    border: 2px solid #fff;
    transform: rotate(-45deg);
  }

  .close:after{
    content:"";
    background:#fff;
    position: absolute;
    width: 24px;
    border: 2px solid #fff;
    transform: rotate(45deg);
  }

  .heading {
    width:100%;
    background: linear-gradient(135deg, #1149F3 0%, #00C3FF 100%);
    padding:14px;
    border-radius:20px 20px 0 0;
    display:flex;
    align-items:center;
    color:#fff;
    font-weight:600;

    .rightInfo {
      margin-left:auto;
    }

    .logoWrap {
      padding:2px 2px 0px 2px;
      border-radius:2px;
      background:#fff;
    }
  }

  .refundTittle {
    background: #195EB7;
    font-family: 'Rubik';
    color:#fff;
    padding:14px 0;
    text-align:center;
    font-size:22px;
    font-weight:600;
  }

  .text-white {
    color:#fff;
  }

  .flex-cont {
    display: flex;
  }
`;

export const SprList = styled.ul`
  display:flex;
  flex-direction: column;

  li{
    display:flex;
    padding:36px;
    border-bottom:4px solid #EFF3F8;

    .iconWrap{
      margin-right:20px;
    }

    h3{
      font-family: 'Rubik';
      font-size:18px;
      color:#141823;
      font-weight:600;
      margin-bottom:5px;
    }

    h4 {
      font-size:14px;
      color:#141823;
      font-weight:600;
      margin-bottom:10px;
    }

    .desText{
      color:#141823;
    }

    .validText{
      color:#777;
    }

    .voucherText{
      color:#18A160;
      margin-bottom:5px;
    }
    &:last-child{
      border-bottom:none;
    }
  }
`;

export const GoAssuredModalImg = styled.img.attrs((props) => ({
    src: props.src || "",
  }))`
    width: 81px;
    height: 23px;
`;

export const BluSmartModalImg = styled.img.attrs((props) => ({
  src: props.src || ""
}))`
  width: 60px;
  height: 30px;
`;

export const ElectricVehicleImg = styled.img.attrs((props) => ({
  src: props.src || ""
}))`
  width: 25px;
  height: 20px;
`;

export const CabConditionImg = styled.img.attrs((props) => ({
  src: props.src || ""
}))`
  width: 52px;
`;

export const GetBtn = styled.button`
  width:171px;
  height:48px;
  border:none;
  outline:none;
  background: #D1E5FF;
  border-radius: 38px;
  color:#2276E3;
  font-family: 'Rubik';
  font-size:18px;
  font-weight:600;
  cursor: pointer;
  margin:0 auto;
`;
